export default "__VITE_ASSET__DKDvPVVz__"